import styled, { css } from 'styled-components';

export const Container = styled.section`
  ${({ theme }) => css`
    background: ${theme.colors.background};
    border-radius: ${theme.radius.default};
    box-shadow: ${theme.shadows.flat};
    padding: 2.4rem;
    width: 100%;
    margin: 2.4rem 0;
  `}
`;

export const Content = styled.div`
  max-width: 680px;
  display: flex;
  justify-content: flex-start;
`;

export const BorderContent = styled.div`
  ${({ theme }) => css`
    width: 100%;
    max-width: 680px;
    border-radius: ${theme.radius.small};
    padding: 10px;
    margin-bottom: 4rem;
    border: 1px solid #e4e4e4;
  `}
`;

export const FlexWrapper = styled.div`
  display: flex;
  gap: 10px;

  @media (max-width: 900px) {
    flex-direction: column;
  }
`;

export const Wrapper = styled.div`
  @media (max-width: 900px) {
    width: 100% !important;
  }
`;

export const LabelContainer = styled.div`
  margin-top: 2rem;
  margin-bottom: 0.5rem;
`;

export const Label = styled.label`
  ${({ theme }) => css`
    font-size: ${theme.fontSizes.default};
    color: ${theme.colors.labelInput};
  `}
`;
